import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

let ctx;
const getCtx = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
  }
  return ctx;
};

// Suono "dlin" stile notifica iPhone: due note brevi cristalline
export function playDlin() {
  try {
    const c = getCtx();
    if (c.state === "suspended") c.resume();
    const now = c.currentTime;
    [[1318.5, 0], [1975.5, 0.12]].forEach(([freq, delay]) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + delay);
      gain.gain.exponentialRampToValueAtTime(0.5, now + delay + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + delay + 0.6);
      osc.connect(gain);
      gain.connect(c.destination);
      osc.start(now + delay);
      osc.stop(now + delay + 0.65);
    });
  } catch (e) { /* noop */ }
}

export default function RepairReadyAlerts() {
  const navigate = useNavigate();
  const since = useRef(new Date().toISOString());

  useEffect(() => {
    const unlock = () => { try { getCtx().resume(); } catch (e) { /* noop */ } };
    window.addEventListener("pointerdown", unlock, { once: true });
    const poll = () => api.get("/repairs/ready-alerts", { params: { since: since.current } }).then(({ data }) => {
      if (!data.length) return;
      since.current = data[data.length - 1].created_at;
      playDlin();
      data.forEach((a) => toast.info(a.message, {
        description: `${a.number ? `#${a.number} · ` : ""}segnalata da ${a.by_name || "—"}`,
        duration: 15000,
        action: { label: "Apri", onClick: () => navigate("/riparazioni") },
      }));
    }).catch(() => {});
    const t = setInterval(poll, 8000);
    return () => { clearInterval(t); window.removeEventListener("pointerdown", unlock); };
  }, [navigate]);

  return null;
}
